import { Observable, merge } from 'rxjs'
import Job, { Resolution } from './Job'
import { filter } from 'rxjs/operators'
import { isNil } from 'lodash'

/**
 * Emits a `Job` any time it's time to show the Job Close dialog.
 *
 * @param requestClose$ tge
 */
export function JobClosingFlow(
  requestClose$: Observable<Job>,
): Observable<Job> {
  return merge(
    // For job closing.
    requestClose$.pipe(
      filter(
        (job) => isNil(job.resolution) || job.resolution === Resolution.Done,
      ),
    ),
  )
}
